import { Navigate, useLocation, useParams } from 'react-router-dom';
import { qrPath, resolveQrToken } from '@helper/qrNavigation';

const LegacyQrRedirect = ({ page = 'home', paramName = '' }) => {
    const params = useParams();
    const location = useLocation();
    const tokenqr = resolveQrToken();
    const identifier = paramName ? params?.[paramName] : '';
    const target = qrPath(tokenqr, page, identifier);

    return <Navigate replace to={`${target}${location.search || ''}${location.hash || ''}`} />;
};

export default LegacyQrRedirect;
